<template>
		<el-dialog title="額度轉移" :visible.sync="centerDialogVisible" class="user-layout-dialog transfer-box" :close-on-click-modal="false">

			<el-row :gutter="20">

				<el-col :span="24">


				<el-form label-width="90px">

					<el-form-item label="轉出">
						<span class="tip-amount" v-if="transfer.out && user.wallet.deploy[transfer.out].amount >= 0">${{ displayAmount(transfer.out) || '0.00'  }}</span>
						<el-select placeholder="請選擇" v-model="transfer.out" @change="changeOut" :clearable="false" disabled>
							<el-option  v-for="item in transfer.outArray" :key="item.value" :label="item.label" :value="item.value" v-if="user.wallet.deploy[item.value]" :disabled="user.wallet.deploy[item.value].amount?item.disabled:true">
								<img :src="item.icon" class="vendor-icon" />
								<span>{{ item.label }}</span>
								<span class="select-right-amount">${{ displayAmount(item.value) || '0.00' }}</span>
							</el-option>
						</el-select>
						 <!-- <el-button class="button-suffix" type="text" @click="go2page('user/deposit')">先去存款</el-button> -->
					</el-form-item>
					<el-form-item label="轉入">
						<span class="tip-amount" v-if="transfer.in && user.wallet.deploy[transfer.in].amount >= 0">${{ displayAmount(transfer.in) || '0.00'}}</span>

						<el-select placeholder="請選擇" v-model="transfer.in" value-key="transfer.in" @change="changeIn" :clearable="false" disabled>
							<el-option  v-for="item in transfer.inArray" :key="item.value" :label="item.label" :value="item.value" v-if="user.wallet.deploy[item.value]" :disabled="item.disabled">
								<img :src="item.icon" class="vendor-icon" />
								<span >{{ item.label }}</span>
								<span style="float: right; color: #8492a6; font-size: 14px">${{ displayAmount(item.value) || '0.00' }}</span>
							</el-option>
						</el-select>
						<div class="rmb-tip" v-if="['VG'].includes(transfer.in)"><i class="el-icon-info"></i> 轉出幣值5:1「轉出10元 = 轉入2元」</div>
					</el-form-item>

					<el-form-item label="金額">
						<el-input class="input-amount" placeholder="請輸入金額" @keyup.enter.native="onSubmit" @keypress.native="$bet.onlyNumber()" v-model="transfer.amount" :value="transfer.amount" :clearable="true"></el-input>
						<!-- <el-button class="button-suffix" type="text" @click="transferAll">全部轉入</el-button> -->
					</el-form-item>

					<el-form-item style="margin-bottom:0px;">
						<el-button type="primary" @click="onSubmit" :loading="transfer.loading" style="width:125px;">確定轉點</el-button>
						<el-button type="primary" @click="startGame" style="width:125px;" plain v-if="this.game['source'] == 'AV'"><i class="el-icon-view"></i> 進入影城</el-button>
						<el-button type="primary" class="black-btn" @click="startGame" style="width:125px;" plain v-else><i class="el-icon-money"></i> 開始下單</el-button>
					</el-form-item>
				</el-form>




				</el-col>
			</el-row>




	</el-dialog>


</template>

<script>
import { mapGetters } from 'vuex'
import { TweenLite } from 'gsap';
export default {
	data() {

		return {
			game:[],
			centerDialogVisible: false,

			transfer: {
				amount:'',
				out : '',
				outArray : [],
				in : '',
				inArray : [],
				loading:false,
			},

		};
	},
	methods: {
		startGame(){

			const loading = this.$loading({
				lock: false,
				text: this.game['source'] == 'AV' ? '影城啟動中':'遊戲啟動中',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

			this.$axios({
				method : 'GET',
				url : this.config.ApiUrl + '/api/' + this.game['source'] + '/start-game/' + this.game['id'] ,
				data: {
				},
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(response => {
				loading.close();
				//console.log(response);
				if (!response.data.status) {
					return this.$layer.msg(response.data.message);
				}
				else {
					this.centerDialogVisible = false;
					if (this.game['source'] == 'AV'){
						window.open(response.data.data.url,'', '');
					}
					else {
						//window.open(response.data.data.url,'', 'height=768,width=1450,location=no,menubar=no,menubar=no');
						window.location.href=response.data.data.url;
					}
				}
			}).catch(error => {
				loading.close();
				console.log(error);
			});		
		},
		refreshBalance(vendor) {
			//console.log(lastKey);
			this.$axios({
				method : 'GET',
				url : this.config.ApiUrl + '/api/get-balance/' + vendor,
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(response => {
				if (response.data.status) {
					//let self = this;

					TweenLite.to(this.user.wallet.deploy[vendor], 0.5, {amount:response.data.data.amount,onComplete:function (){
						//self.refreshPercents();
					}});
				}

			}).catch(error => {
				console.log(error);
			});
		},
		displayAmount(args){
			return parseFloat(this.user.wallet.deploy[args].amount).toFixed(2);
		},
		changeOut(value){
			for (var i=0;i < this.transfer.inArray.length; i++){
				this.transfer.inArray[i].disabled = false;
				if (this.transfer.inArray[i].value == value){
					this.transfer.inArray[i].disabled = true;
				}
			}

		},
		changeIn(value){
			for (var i=0;i < this.transfer.outArray.length; i++){
				this.transfer.outArray[i].disabled = false;
				if (this.transfer.outArray[i].value == value){
					this.transfer.outArray[i].disabled = true;
				}
			}

		},
        go2page(page){
			this.centerDialogVisible = false;
            let cmd = page;
            this.$router.push('/' + cmd);
        },
		open(source,id) {
			this.centerDialogVisible = true;
			this.game['source'] = source;
			this.game['id'] = id;

			this.transfer.out = 'WALLET';
			this.transfer.in = source;

			this.refreshBalance(this.transfer.out);
			this.refreshBalance(this.transfer.in);
		},
		transferAll(){
			if(!this.transfer.out) {
				return this.$layer.msg('請選擇轉出平台');
			}
			var amount = parseInt(this.user.wallet.deploy[this.transfer.out].amount);
			if(!amount) {
				return this.$layer.msg('金額不足');
			}
			this.transfer.amount = amount;
		},
		onSubmit() {
			if(!this.transfer.out) {
				return this.$layer.msg('請選擇轉出帳戶');
			}
			if(!this.transfer.in) {
				return this.$layer.msg('請選擇轉入帳戶');
			}
			if (!this.transfer.amount || parseFloat(this.transfer.amount) < 1)
			{
				return this.$layer.msg('請輸入金額');
			}

			this.transfer.amount = parseFloat(this.transfer.amount);

			if (this.transfer.amount > this.user.wallet.deploy[this.transfer.out].amount)	{
				this.transfer.amount = this.user.wallet.deploy[this.transfer.out].amount;
				return this.$layer.msg('金額不得大於' + this.user.wallet.deploy[this.transfer.out].amount);

			}


			this.transfer.loading = true;
			this.$axios({
				method : 'POST',
				url : this.config.ApiUrl + '/api/transfer' ,
				data: {
					'amount' : this.transfer.amount,
					'from' : this.transfer.out,
					'to' : this.transfer.in
				},
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(response => {
				//console.log(response.data);
				this.$layer.msg(response.data.message);
				if (response.data.status){
					this.user.wallet.deploy[this.transfer.out].amount = this.user.wallet.deploy[this.transfer.out].amount - parseFloat(this.transfer.amount);
					//this.user.wallet.deploy[this.transfer.in].amount = this.user.wallet.deploy[this.transfer.in].amount + parseFloat(this.transfer.amount);
					setTimeout(() => {
						this.refreshBalance(this.transfer.out);
						this.refreshBalance(this.transfer.in);
					}, 100);
					//this.transfer.amount = '';
				}
				this.transfer.loading = false;

			}).catch(error => {
				console.log(error);
			});



		}
	},
    computed: {
		...mapGetters({
			config: 'config',
			user: 'user',
		}),
    },
	created() {
		//console.log(this.user.wallet.deploy['WALLET']);
		//console.log(typeof this.user.wallet.deploy.lenght);
		//if (!this.user.wallet.refresh){
		//console.log(this.config.vendors);
		if (typeof this.user.wallet.deploy['WALLET'] == 'undefined') {
		
			for (var key in this.config.vendors) {
				this.$set(this.user.wallet.deploy, this.config.vendors[key].value, {amount:0,percent:0});

			}
			for (var key in this.config.vendors) {
				//this.refreshBalance(this.config.vendors[key].value);
			}
			this.user.vendorsCount = this.config.vendors.length;
			this.user.wallet.refresh = false;
		}
		for (var key in this.config.vendors) {
			if(!this.user.wallet.deploy[this.config.vendors[key].value])
			{
				this.$set(this.user.wallet.deploy, this.config.vendors[key].value, {amount:0,percent:0});
			}
			this.transfer.outArray.push({
				value: this.config.vendors[key].value,
				label: this.config.vendors[key].label,
				icon: this.config.vendors[key].icon,
				disabled: false
			});
			this.transfer.inArray.push({
				value: this.config.vendors[key].value,
				label: this.config.vendors[key].label,
				icon: this.config.vendors[key].icon,
				disabled: false
			});

		}
		//console.log(this.transfer);

		Object.assign({}, this.transfer.outArray);
		Object.assign({}, this.transfer.inArray);
	}
}
</script>
<style>


.transfer-box .el-form-item__label {
	font-size:15px;
}

 .el-select-dropdown__item .vendor-icon{
	vertical-align:middle;
	margin-right:5px;
	margin-left:-5px;
	width:26px;
	height:26px;
	border: 1px solid #ddd;
    border-radius: 50%;
}
.el-select-dropdown__item .select-right-amount{
	float: right;
	color: #8492a6;
	font-size: 14px
}

.transfer-box .tip-amount{
	position: absolute;
	left: 125px;
	color:rgb(192, 203, 218);
	font-size:15px;
	text-align: right;
	width:100px;
	z-index:1;
}
.transfer-box .tip-amount{
	position: absolute;
	left: 125px;
	color:rgb(192, 203, 218);
	font-size:15px;
	text-align: right;
	width:100px;
	z-index:1;
}
.transfer-box .black-btn {
	color: #E4BB7B;
	background: #333f56;
    border-color: #E4BB7B;
}
.transfer-box .black-btn:hover {
	color: #666;
	background: #E4BB7B;
    border-color: #E4BB7B;
}
.transfer-box .el-input.is-disabled .el-input__inner {
    background-color: transparent;
	border: 1px solid #dcdfe6;
    cursor: not-allowed;
}
.transfer-box .el-dialog__body {
    color: #ddd;
    background-color: #333f56;
}
.transfer-box .el-select,.transfer-box .input-amount{width:262px;}

.transfer-box .button-suffix {margin-left:5px;font-size:15px;}
.transfer-box .el-button {font-size:15px;}
.transfer-box .rmb-tip {
	position: absolute;
    top: 32px;
    font-size: 12px;
	color:#e91e63;
}
</style>


// WEBPACK FOOTER //
// src/components/TransferBox.vue